/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/function-component-definition */
import React, { Children, createElement, ReactElement } from 'react';

import { TFormField } from '../shared/utils/types';

import type { IBuilderProps } from './_props';

/**
 * Form Builder
 */

const Builder = <TFormFields extends TFormField = TFormField>({
  className = '',
  id = '',
  children,
  onSubmit,
  formMethods,
}: IBuilderProps<TFormFields>) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = formMethods;

  const processChildren = (childElements: React.ReactNode): React.ReactNode =>
    Children.map(childElements, (child) => {
      let newChild = child;
      if (React.isValidElement(newChild)) {
        const element = newChild as ReactElement;

        if (element.props.children) {
          newChild = React.cloneElement(element, {
            children: processChildren(element.props.children),
          });
        }

        if (element.props.name) {
          return createElement(element.type, {
            ...{
              ...element.props,
              key: element.props.name,
              register,
              state: errors[element.props.name] ? 'Error' : element.props.state ?? 'Default',
              errorMessage: errors[element.props.name]?.message as string,
            },
          });
        }
      }

      return newChild;
    });

  return (
    <form id={id} onSubmit={handleSubmit(onSubmit)} className={className}>
      {processChildren(children)}
    </form>
  );
};

/**
 * Exports
 */

export { IBuilderProps };

export default Builder;
